/* import __COLOCATED_TEMPLATE__ from './rollover.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { validatable, Length, NotBlank } from 'ilios-common/decorators/validation';
import { dropTask, restartableTask, timeout } from 'ember-concurrency';
import { DateTime } from 'luxon';
import { filterBy, mapBy } from 'ilios-common/utils/array-helpers';
let CourseRolloverComponent = (_dec = Length(3, 200), _dec2 = NotBlank(), _dec3 = NotBlank(), validatable(_class = (_class2 = class CourseRolloverComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "fetch", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor3, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor4, this);
    _initializerDefineProperty(this, "title", _descriptor5, this);
    _initializerDefineProperty(this, "selectedYear", _descriptor6, this);
    _initializerDefineProperty(this, "years", _descriptor7, this);
    _initializerDefineProperty(this, "course", _descriptor8, this);
    _initializerDefineProperty(this, "startDate", _descriptor9, this);
    _initializerDefineProperty(this, "skipOfferings", _descriptor10, this);
    _initializerDefineProperty(this, "allCourses", _descriptor11, this);
    _initializerDefineProperty(this, "selectedCohorts", _descriptor12, this);
    _initializerDefineProperty(this, "academicYearCrossesCalendarYearBoundaries", _descriptor13, this);
    _defineProperty(this, "load", _buildTask(() => ({
      context: this,
      generator: function* (event, [course]) {
        if (!course) {
          return;
        }
        this.title = course.title;
        const school = course.belongsTo('school').id();
        this.academicYearCrossesCalendarYearBoundaries = yield this.iliosConfig.itemFromConfig('academicYearCrossesCalendarYearBoundaries');
        this.allCourses = yield this.store.query('course', {
          filters: {
            school
          }
        });

        // set selectedYear to next valid year (or current if none found)
        const validYear = this.years.find(year => !this.unavailableYears.includes(year));
        this.changeSelectedYear(validYear || this.years[0]);
      }
    }), null, "load", "restartable"));
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(1);
        this.addErrorDisplayForAllFields();
        const isValid = yield this.isValid();
        if (!isValid) {
          return false;
        }
        const courseId = this.args.course.id;
        const selectedCohortIds = mapBy(this.selectedCohorts, 'id');
        const data = {
          year: this.selectedYear,
          newCourseTitle: this.title
        };
        if (this.startDate) {
          data.newStartDate = DateTime.fromJSDate(this.startDate).toFormat('yyyy-LL-dd');
        }
        if (this.skipOfferings) {
          data.skipOfferings = true;
        }
        if (selectedCohortIds && selectedCohortIds.length) {
          data.newCohorts = selectedCohortIds;
        }
        const newCoursesObj = yield this.fetch.postQueryToApi(`courses/${courseId}/rollover`, data);
        this.flashMessages.success('general.courseRolloverSuccess');
        this.store.pushPayload(newCoursesObj);
        const newCourse = this.store.peekRecord('course', newCoursesObj.data.id);
        return this.args.visit(newCourse);
      }
    }), null, "save", "drop"));
    let {
      month,
      year: _year
    } = DateTime.now();
    _year--; // start with the previous year
    if (month < 7) {
      // before July 1st (start of a new academic year) show the year before
      _year--;
    }
    this.years = [];
    for (let i = 0; i < 6; i++) {
      this.years.push(_year + i);
    }
  }
  changeTitle(newTitle) {
    this.title = newTitle;
  }
  addCohort(cohort) {
    this.selectedCohorts = [...this.selectedCohorts, cohort];
  }
  removeCohort(cohort) {
    this.selectedCohorts = this.selectedCohorts.filter(obj => obj !== cohort);
  }
  get unavailableYears() {
    if (!this.allCourses) {
      return [];
    }
    const existingCoursesWithTitle = filterBy(this.allCourses, 'title', this.title.trim());
    return mapBy(existingCoursesWithTitle, 'year');
  }
  setSelectedYear(event) {
    this.changeSelectedYear(event.target.value);
  }
  changeSelectedYear(selectedYear) {
    this.selectedYear = Number(selectedYear);
    const from = DateTime.fromJSDate(this.args.course.startDate);
    this.startDate = DateTime.fromObject({
      hour: 0,
      minute: 0,
      weekYear: Number(selectedYear),
      weekNumber: from.weekNumber,
      weekday: from.weekday
    }).toJSDate();
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "fetch", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec, _dec2, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "selectedYear", [_dec3, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "years", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "course", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "startDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "skipOfferings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "allCourses", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "selectedCohorts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "academicYearCrossesCalendarYearBoundaries", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "changeTitle", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addCohort", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addCohort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeCohort", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeCohort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setSelectedYear", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setSelectedYear"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeSelectedYear", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeSelectedYear"), _class2.prototype), _class2)) || _class);
export { CourseRolloverComponent as default };